// @flow
import { getLogger } from "@cld/upload-widget";
import createBoundActionCreators, { createCustomCreator } from "common/actionsBase";
import getCloudInfoWithAnalytics from "../cloudInfo";
import { selectLatestConfig, selectConsoleInfo } from "./selectors";

const logger = getLogger();

export const types = {
	SET_UPLOADER_CONFIG: "SET_UPLOADER_CONFIG",
	SET_UPLOADER_CLOUD_INFO: "SET_UPLOADER_CLOUD_INFO",
	SET_UPLOADER_QS_PARAMS: "SET_UPLOADER_QS_PARAMS",
	SET_UPLOADER_CURRENT_SOURCE: "SET_UPLOADER_CURRENT_SOURCE",
	SET_UPLOADER_BATCH_PREPARED: "SET_UPLOADER_BATCH_PREPARED",
	SET_UPLOADER_FILE_PROGRESS: "SET_UPLOADER_FILE_PROGRESS",
	SET_UPLOADER_FILE_PAUSED: "SET_UPLOADER_FILE_PAUSED",
	SET_UPLOADER_QUEUE_RUNNING_FOR_FILE: "SET_UPLOADER_QUEUE_RUNNING_FOR_FILE",
	SET_UPLOADER_QUEUE_METADATA: "SET_UPLOADER_QUEUE_METADATA",
	SET_UPLOADER_FILE_DONE: "SET_UPLOADER_FILE_DONE",
	SET_UPLOADER_FILE_DATA_METHODS: "SET_UPLOADER_FILE_DATA_METHODS",
	SET_UPLOADER_FILE_PREVIEW: "SET_UPLOADER_FILE_PREVIEW",
	SET_UPLOADER_FILE_COORDINATES: "SET_UPLOADER_FILE_COORDINATES",
	SET_UPLOADER_SHOW: "SET_UPLOADER_SHOW",
	SET_UPLOADER_HIDE: "SET_UPLOADER_HIDE",
	SET_UPLOADER_MINIMIZE: "SET_UPLOADER_MINIMIZE",
	SET_UPLOADER_QUEUE_FINISHED: "SET_UPLOADER_QUEUE_FINISHED",
	SET_UPLOADER_PUBLICID: "SET_UPLOAD_PUBLICID",
	SET_UPLOADER_TAGS: "SET_UPLOAD_TAGS",
	SET_UPLOADER_UPLOAD_PRESET: "SET_UPLOAD_UPLOAD_PRESET",
	SET_UPLOADER_RETRIEVED_TAGS: "SET_UPLOADER_RETRIEVED_TAGS",
	SET_UPLOADER_RETRIEVED_UPLOAD_PRESETS: "SET_UPLOADER_RETRIEVED_UPLOAD_PRESETS",
	SET_UPLOADER_RETRY_FILES: "SET_UPLOADER_RETRY_FILES",
	SET_UPLOADER_FILES_QUEUED: "SET_UPLOADER_FILES_QUEUED",
	SET_UPLOADER_ADD_CLIENT_UPLOAD: "SET_UPLOADER_ADD_CLIENT_UPLOAD",
	SET_UPLOADER_START_CLIENT_BATCH: "SET_UPLOADER_START_CLIENT_BATCH",
	SET_UPLOADER_PID_COUNTER: "SET_UPLOADER_PID_COUNTER",
	SET_UPLOADER_QUEUE_PRECALLS_PENDING: "SET_UPLOADER_QUEUE_PRECALLS_PENDING",
	SET_UPLOADER_FILE_PRECALLS_DELAYED_OFF: "SET_UPLOADER_FILE_PRECALLS_DELAYED_OFF",
	CLEAR_UPLOADER_QUEUES: "CLEAR_UPLOADER_QUEUES",
	CLEAR_UPLOADER_CLIENT_BATCH: "CLEAR_UPLOADER_CLIENT_BATCH",
	CANCEL_UPLOADER_FILES: "CANCEL_UPLOADER_FILES",
	START_CLEAR_QUEUES: "START_CLEAR_QUEUES",
	END_CLEAR_QUEUES: "END_CLEAR_QUEUES",
	UPDATE_CLOUD_INFO: "UPDATE_CLOUD_INFO",
	CLEAN_POST_BATCH_PROP_LIST: "CLEAN_POST_BATCH_PROP_LIST",
};

export default createBoundActionCreators(types, {
	[types.SET_UPLOADER_START_CLIENT_BATCH]:
		createCustomCreator((data: Object, dispatch: Function, getState: Function, dispatcher: Function) => {
			const config = selectLatestConfig(getState());

			data = {
				...data,
				config: { ...config }, // make copy of last queue config to be used when creating a queue from this batch
			};

			dispatcher(types.SET_UPLOADER_START_CLIENT_BATCH, data);
		}),

	[types.UPDATE_CLOUD_INFO]:
		createCustomCreator(async (data: { config: Object }, dispatch: Function, getState: Function, dispatcher: Function) => {
			const consoleInfo  = selectConsoleInfo(getState());

			if (!consoleInfo.onDevConsole) { // dont bother with cloud info when on cloudinary's dev environment
				const info = await getCloudInfoWithAnalytics(data.config, consoleInfo);

				if (info) {
					logger.log("[uploader.stateProcessors]: received cloud info from server: ", info);
					dispatcher(types.SET_UPLOADER_CLOUD_INFO, info);
				}
			}
		}),
});
